let initialData = null;
let currentTypeId = null;
let currentData = [];
let filters = [];
let types = []
let tagsAvailable = [];

const dataSubscribers = [];
const filtersSubscribers = [];
const searchSubscribers = [];

let filtersActive = {
    recherche: [],
    tags : [],
    range: []
}

const registerData = (data) => {

    if(!data) return false;

    initialData = data;
    currentTypeId = data.params.default;
    currentData = data.types[currentTypeId];

    for (const item in data.types){
        const type = data.types[item];
        types.push({
            id: type.id,
            label: type.label,
            active: type.id === currentTypeId
        });
    }

    const allRessources = [];
    for(const key in data.types){
        allRessources.push(...data.types[key].data);
    }

    const finalFilters = [];
    data.filtres.forEach(groupe => {
        if(groupe.id === "annees"){
            finalFilters.push(groupe);
        } else {
            const nextData = groupe.data.reduce((prev, tag) => {
                const isUsed = allRessources.find(item => item.tags.includes(tag.id) && groupe.types.indexOf(item.type) !== -1);
                // if(isUsed && groupe.types.indexOf(isUsed.type) !== -1) prev.push(tag);
                if(isUsed) prev.push(tag);
                return prev;
            }, []);
            groupe.data = nextData;
            finalFilters.push(groupe);
        }
    });

    filters = _initFilters(finalFilters);

    _publishData();
}

const setItemSelected = (itemSelected) => {
    currentData.data.map(item => {
        if(item === itemSelected){
            return item.selected = !item.selected;
        } else {
            return item.selected = false
        }
    });
    _publishData();
}

const subscribeData = (subscriber) => {
    if(dataSubscribers.indexOf(subscriber) === -1){
        dataSubscribers.push(subscriber);
        _publishData();
        return _unsubscribeData;
    }
}

const subscribeFilters = (subscriber) => {
    if(filtersSubscribers.indexOf(subscriber) === -1){
        filtersSubscribers.push(subscriber);
        _publishFilters();
        return _unsubscribeFilters;
    }
}

const subscribeSearch = (subscriber) => {
    if(searchSubscribers.indexOf(subscriber) === -1){
        searchSubscribers.push(subscriber);
        return _unsubscribeSearch;
    }
}

const setTextSearch = (params) => {
    filtersActive = Object.assign(filtersActive, params);
    setItemSelected(null);
    _publishSearch();
    _publishData();
}

const clearSearch = () => {
    filtersActive.recherche = [];
    _publishSearch();
}

const toggleFilterActive = (filterId) => {

    if(filtersActive.tags.indexOf(filterId) === -1){
        filtersActive.tags.push(filterId);
    } else {
        filtersActive.tags.splice(filtersActive.tags.indexOf(filterId), 1);
    }

    filters.forEach(groupe => {
        if(groupe.input !== 'range'){
            return groupe.data.map(filter => {
                if(filtersActive.tags.indexOf(filter.id) !== -1){
                    return filter.active = true;
                } else {
                    return filter.active = false;
                }
            });
        }
    });
    _publishFilters();
    _publishData();
}

const setRangeFilter = (range) => {
    filtersActive.range = range;
    const rangeFilter = filters.find(filter => filter.input === 'range');
    rangeFilter.currentRange = range;
    _publishFilters();
    _publishData();
}

const clearTags = () => {
    filtersActive.tags = [];
    filtersActive.range = [];
    filters.forEach(filter => {
        if(filter.input === 'range'){
            filter.currentRange = [filter.data[0], filter.data[filter.data.length -1]];
        }
    });
    _publishFilters();
    _publishData();
}

const getTypes = () => {
    return types;
}

const setCurrentType = (typeId) => {
    currentTypeId = typeId;
    types.forEach(type => {
        type.active = type.id === typeId;
    });
    currentData = initialData.types[currentTypeId];
    filtersActive.recherche = [];
    filtersActive.tags = [];
    filtersActive.range = [];
    filters.forEach(filter => {
        if(filter.input === 'range'){
            filter.currentRange = [filter.data[0], filter.data[filter.data.length -1]];
        }
    });
    filters = _initFilters(initialData.filtres);
    _publishFilters();
    _publishData();
}

/* METHODES PRIVEES */

const _filteredData = () => {

    let filteredItems = currentData.data;

    if(filtersActive.recherche.length){
        filteredItems = _filterByRecherche(filteredItems);
    }
    
    if(filtersActive.tags.length){
        filteredItems = _filterByTags(filteredItems);
    }

    if(filtersActive.range.length){
        filteredItems = _filterByRange(filteredItems);
    }

    // Mise à jour de la liste des tags disponibles
    tagsAvailable = [];
    if(filteredItems){
        filteredItems.forEach(item => {
            tagsAvailable = [...tagsAvailable, ...item.tags]
        });
    }

    _initFilters(filters);

    return filteredItems;

}

const _initFilters = (data) => {

    let newFilters = [];

    data.forEach(group => {
        if(group.types.indexOf(currentTypeId) !== -1){
            switch(group.input){
                case 'checkbox':
                    group.data.forEach(filter => {
                        filter.active = filtersActive.tags.indexOf(filter.id) !== -1;
                        filter.disabled = tagsAvailable.indexOf(filter.id) === -1;
                    });
                    newFilters.push(group);
                    break;
                case 'range':
                    group.currentRange = group.currentRange ? group.currentRange : [group.data[0], group.data[group.data.length-1]];
                    newFilters.push(group);
                    break;
                default:
                    newFilters.push(group);
                    
            }
        }
    });

    return newFilters;
}

const _filterByRecherche = (data) => {

    
    const pattern = [...filtersActive.recherche].join(' ');
    const minuscules = pattern.toLowerCase();
    const sansAccents = minuscules.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    
    if(!pattern) return data;
    
    const newresult = data.reduce((output, item) => {
        const distance = item.search.indexOf(sansAccents);
        
        if(distance !== -1){
            output.push({
                ressource: item,
                score: distance
            });
        }

        return output;

    }, []);

    if(newresult.length){
    
        newresult.sort((a, b) => {
            if(a.score < b.score) return -1;
            if(a.score > b.score) return 1;
            return 0;
        });

        const finalResult = newresult.map(object => object.ressource);
    
        return finalResult;

    } else {

        return [];

    }
}

const _filterByTags = (data) => {
    const activesTags = filtersActive.tags.sort().toString();
    return data.filter(item => {
        const intersection = filtersActive.tags.filter(e => item.tags.includes(e));
        return intersection.sort().toString() === activesTags;
    });
}

const _filterByRange = (data) => {
    return data.filter(item => {
        return item.annee >= filtersActive.range[0] && item.annee <= filtersActive.range[1];
    });
}

const _publishData = () => {
    const dataToPublish = _filteredData();
    dataSubscribers.map(subscriber => {
        return subscriber(dataToPublish);
    });
}

const _publishFilters = () => {
    filtersSubscribers.map(subscriber => {
        return subscriber([...filters]);
    });
}

const _publishSearch = () => {
    searchSubscribers.map(subscriber => {
        return subscriber(filtersActive.recherche.join(' '));
    });
}

const _unsubscribeData = (subscriber) => {
    dataSubscribers.splice(dataSubscribers.indexOf(subscriber), 1);
}

const _unsubscribeFilters = (subscriber) => {
    filtersSubscribers.splice(filtersSubscribers.indexOf(subscriber), 1);
}

const _unsubscribeSearch = (subscriber) => {
    searchSubscribers.splice(searchSubscribers.indexOf(subscriber), 1);
}

export { 
    registerData, 
    setItemSelected, 
    subscribeData, 
    subscribeFilters, 
    subscribeSearch, 
    setTextSearch, 
    clearSearch, 
    toggleFilterActive, 
    setRangeFilter, 
    clearTags, 
    getTypes, 
    setCurrentType 
}